const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCal2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4845_7307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3778 4.89844H9.6377M31.7001 4.89844H26.9611M44.2845 4.89844H46.0817C47.7064 4.89844 49.0234 6.21553 49.0234 7.84004V46.0815C49.0234 47.7062 47.7064 49.0231 46.0817 49.0231H3.91826C2.29355 49.0231 0.976562 47.7062 0.976562 46.0815V7.84004C0.976562 6.21553 2.29355 4.89844 3.91826 4.89844H5.71553M40.3622 4.89844H35.6223M23.0389 4.89844H18.2999M0.976562 14.7039H49.0234",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67686 10.782C6.59375 10.782 5.71582 9.9041 5.71582 8.8209V2.9377C5.71582 1.85449 6.59375 0.976562 7.67686 0.976562C8.75996 0.976562 9.63789 1.85449 9.63789 2.9377V8.8209C9.63789 9.9041 8.75996 10.782 7.67686 10.782ZM16.3385 10.782C15.2553 10.782 14.3773 9.9041 14.3773 8.8209V2.9377C14.3773 1.85449 15.2553 0.976562 16.3385 0.976562C17.4215 0.976562 18.2995 1.85449 18.2995 2.9377V8.8209C18.2995 9.9041 17.4214 10.782 16.3385 10.782ZM24.9999 10.782C23.9168 10.782 23.0388 9.9041 23.0388 8.8209V2.9377C23.0388 1.85449 23.9168 0.976562 24.9999 0.976562C26.083 0.976562 26.961 1.85449 26.961 2.9377V8.8209C26.961 9.9041 26.083 10.782 24.9999 10.782ZM33.6613 10.782C32.5783 10.782 31.7003 9.9041 31.7003 8.8209V2.9377C31.7003 1.85449 32.5783 0.976562 33.6613 0.976562C34.7445 0.976562 35.6225 1.85449 35.6225 2.9377V8.8209C35.6225 9.9041 34.7445 10.782 33.6613 10.782ZM42.3229 10.782C41.2398 10.782 40.3619 9.9041 40.3619 8.8209V2.9377C40.3619 1.85449 41.2398 0.976562 42.3229 0.976562C43.4061 0.976562 44.284 1.85449 44.284 2.9377V8.8209C44.284 9.9041 43.406 10.782 42.3229 10.782Z",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.603 18.6309V25.4867H12.7473V18.6309H19.603Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4277 18.6309V25.4867H21.572V18.6309H28.4277Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2529 18.6309V25.4867H30.3972V18.6309H37.2529Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0776 18.6309V25.4867H39.2219V18.6309H46.0776Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 28.4355V35.2914H3.92197V28.4355H10.7778Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.603 28.4355V35.2914H12.7473V28.4355H19.603Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4516 30.8485L23.9602 34.3152L22.5734 32.9285M18.6266 40.6539L15.1105 44.1207L13.7239 42.734M45.1014 40.6539L41.5854 44.1207L40.1987 42.734M9.80166 21.043L6.28564 24.5098L4.89893 23.123",
    stroke: "#5A045A",
    style: {
      stroke: "#5A045A",
      stroke: "color(display-p3 0.3529 0.0157 0.3529)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2529 28.4355V35.2914H30.3972V28.4355H37.2529Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0776 28.4355V35.2914H39.2219V28.4355H46.0776Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7778 38.2412V45.0971H3.92197V38.2412H10.7778Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4277 38.2412V45.0971H21.572V38.2412H28.4277Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2529 38.2412V45.0971H30.3972V38.2412H37.2529Z",
    fill: "#FDD39E",
    style: {
      fill: "#FDD39E",
      fill: "color(display-p3 0.9922 0.8275 0.6196)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4845_7307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal2);
export default __webpack_public_path__ + "static/media/cal2.59467045263214e47ec72505f94d63d5.svg";
export { ForwardRef as ReactComponent };